import {
  endOfDay,
  format,
  isSameDay,
  startOfDay,
} from 'date-fns';

export function toCalendarDate(value) {
  if (!value) return null;
  if (typeof value.toDate === 'function') return value.toDate();
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function eventOccursOnDate(event, date) {
  const start = toCalendarDate(event?.startDate);
  const end = toCalendarDate(event?.endDate) || start;
  if (!start || !end || !date) return false;

  const dayStart = startOfDay(date);
  const dayEnd = endOfDay(date);
  return start <= dayEnd && end >= dayStart;
}

export function eventsForDate(events = [], date) {
  return events
    .filter((event) => eventOccursOnDate(event, date))
    .sort((a, b) => {
      const aStart = toCalendarDate(a.startDate)?.getTime() || 0;
      const bStart = toCalendarDate(b.startDate)?.getTime() || 0;
      return aStart - bStart;
    });
}

export function formatAgendaTime(event) {
  if (event?.allDay) return 'All day';
  const start = toCalendarDate(event?.startDate);
  const end = toCalendarDate(event?.endDate);
  if (!start) return 'Time not set';
  if (!end || !isSameDay(start, end)) return format(start, 'HH:mm');
  return `${format(start, 'HH:mm')}–${format(end, 'HH:mm')}`;
}

export function formatAgendaDate(event) {
  const start = toCalendarDate(event?.startDate);
  if (!start) return 'Date not set';
  return format(start, 'EEE, d MMM');
}
